import React, { useEffect, useState } from "react";
import "./JobPost.css";
import "../../../node_modules/react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { getAllcareer } from "../../actions/JobPostAction";
import { Link, NavLink } from "react-router-dom";
import { FaRegCircleXmark, FaDownload } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import ReactPaginate from "react-paginate";
import axios from "axios";
import { toast } from "react-toastify";
import { mainurl } from "../../actions/mainurl";

function AllJob() {
    const dispatch = useDispatch();
    const [showDetailsIndex, setShowDetailsIndex] = useState(null);
    const { user } = useSelector((state) => state.authState);
    const { allCareer } = useSelector((state) => state.careerState);
    const [deleteData, setDeleteData] = useState("");
    const [itemOffset, setItemOffset] = useState(0);

    const baseUrl = mainurl;
    const itemsPerPage = 10;
    const careerApplications = Array.isArray(allCareer) ? allCareer : [];

    const handleQuerieDelete = async (id) => {
        if (user?.role !== "super-admin") {
            toast.error(`Role ${user?.role} is not allowed to delete`);
            return;
        }

        const confirmDelete = window.confirm("Are you sure you want to delete");
        if (!confirmDelete) {
            return;
        }

        try {
            await axios.delete(`${baseUrl}/career/delete-career/${id}`, { withCredentials: true });
            toast.success("Successfully deleted");
            setDeleteData(id);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to delete application");
        }
    };

    useEffect(() => {
        dispatch(getAllcareer);
    }, [deleteData, dispatch]);

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = careerApplications.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(careerApplications.length / itemsPerPage);

    const handlePageClick = (event) => {
        if (!careerApplications.length) {
            setItemOffset(0);
            return;
        }

        const newOffset = (event.selected * itemsPerPage) % careerApplications.length;
        setItemOffset(newOffset);
    };

    return (
        <div className="JobPost_main_div">
            <div className="JobPost_div">
                <div className="JobCreate_button_div">
                    <Link to="/jobpost" className="JobCreate_Button">
                        Job Post
                    </Link>
                    <NavLink to="/alljobdata" className="JobCreate_Button">
                        All job
                    </NavLink>
                </div>
                <div className="query">
                    <h2>All Job Applications</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Cover Letter</th>
                                <th style={{ paddingLeft: "26px" }}>Resume</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((data, index) => {
                                const coverLetter = data.coverLetter?.trim() || "No cover letter provided";

                                return (
                                    <React.Fragment key={data._id || index}>
                                        <tr>
                                            <td className="query_name">{data.fullName || "-"}</td>
                                            <td className="query_email">{data.emailAddress || "-"}</td>
                                            <td className="query_content">
                                                {coverLetter.length > 100
                                                    ? `${coverLetter.substring(0, 50)}..... `
                                                    : coverLetter}
                                                {coverLetter.length > 100 && (
                                                    <button
                                                        className="querie_more_button"
                                                        onClick={() => setShowDetailsIndex(index)}
                                                    >
                                                        more
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {data.resume ? (
                                                    <a
                                                        href={data.resume}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="querie_button"
                                                    >
                                                        <FaDownload />
                                                    </a>
                                                ) : (
                                                    <span
                                                        className="querie_button"
                                                        style={{ opacity: 0.5, cursor: "not-allowed" }}
                                                    >
                                                        <FaDownload />
                                                    </span>
                                                )}
                                                <button
                                                    className="querie_button"
                                                    onClick={() => handleQuerieDelete(data._id)}
                                                >
                                                    <MdDelete className="icon" />
                                                </button>
                                            </td>
                                        </tr>
                                        {showDetailsIndex === index && (
                                            <tr>
                                                <td colSpan="4">
                                                    <div className="showMore_popup_background"></div>
                                                    <div className="showMore_popup">
                                                        <div>
                                                            <FaRegCircleXmark
                                                                className="query_close_icon"
                                                                onClick={() => setShowDetailsIndex(null)}
                                                            />
                                                        </div>
                                                        <div className="query_popup_div">
                                                            <div><b>Name : </b>{data.fullName || "-"}</div>
                                                            <div><b>Email : </b>{data.emailAddress || "-"}</div>
                                                            <div><b>Position : </b>{data.position || "-"}</div>
                                                            <p><b>Cover Letter : </b>{coverLetter}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {!currentItems.length && (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No job applications found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel="next >"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel="< previous"
                        renderOnZeroPageCount={null}
                        className="pagination"
                    />
                </div>
            </div>
        </div>
    );
}

export default AllJob;
